<template>
    <div class="song-grid-right">
        <div class="share">
            <h5>&nbsp;&nbsp;分享</h5>
            <ul>
                <li>
                    <social-sharing :url="shareUrl" :title="videoData.title" :description="(videoData.content == null)?videoData.content:videoData.content.replace(/(<(\/[^>]+)>)/ig, '\r\n').replace(/(<([^>]+)>)/ig, '')" inline-template>
                        <div>
                            <network network="facebook">
                                <a href="javascript:void(0)" class="icon fb-icon">
                                    <i class="fa fa-fw fa-facebook"></i>Facebook
                                </a>
                            </network>
                        </div>
                    </social-sharing>
                </li>
                <li>
                    <social-sharing :url="shareUrl" :title="videoData.title" :description="(videoData.content == null)?videoData.content:videoData.content.replace(/(<(\/[^>]+)>)/ig, '\r\n').replace(/(<([^>]+)>)/ig, '')" inline-template>
                        <div>
                            <network network="twitter">
                                <a href="javascript:void(0)" class="icon twitter-icon">
                                    <i class="fa fa-fw fa-twitter"></i> Twitter
                                </a>
                            </network>
                        </div>
                    </social-sharing>
                </li>
                <li>
                    <social-sharing :url="shareUrl" :title="videoData.title" :description="(videoData.content == null)?videoData.content:videoData.content.replace(/(<(\/[^>]+)>)/ig, '\r\n').replace(/(<([^>]+)>)/ig, '')" inline-template>
                        <div>
                            <network network="line">
                                <a href="javascript:void(0)" class="icon line-icon">
                                    <i class="fa fa-fw fa-line"></i> Line
                                </a>
                            </network>
                        </div>
                    </social-sharing>
                </li>
                <!--<li>-->
                    <!--<a :href="'#'+type+'-embed-dialog-'" class="icon embed-icon popup-with-zoom-anim">嵌入碼</a>-->
                    <!--<div :id="type+'-embed-dialog-'" class="mfp-hide mfp-video-embed-dialog">-->
                        <!--<h3>嵌入碼</h3>-->
                        <!--<textarea class="form-control" v-html="embedCode" rows="3"></textarea>-->
                        <!--<div class="clearfix"></div>-->
                    <!--</div>-->
                <!--</li>-->
                <!--<li class="view" v-if="type=='vod' || videoCounterView=='true'">{{ videoCounter }} Views</li>-->
                <!--<li v-if="$session.exists() && type=='vod'">-->
                    <!--<a class="icon download-icon"-->
                       <!--:href="videoDownload?videoDownload.replace('downloadId', $session.get('kccFrontVueGid')):''"-->
                       <!--target="_blank">下載影片</a>-->
                <!--</li>-->
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  name: '',
  props: ['shareUrl', 'videoData', 'videoDownload', 'embedCode', 'videoCounter', 'videoCounterView', 'type'],
  watch: {
    '$route' (to, from) {
    }
  },
  mounted () {
    $(document).ready(function () {
      $('.popup-with-zoom-anim').magnificPopup({
        type: 'inline',
        fixedContentPos: false,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
        mainClass: 'my-mfp-zoom-in'
      })
    })
  }
}
</script>
